import { getImageUrl } from "utils";

export const buildImageSlides = (item, defectLabel = "Defect") => {
  const slides = [];
  (item?.sub_items || []).forEach(si => {
    if (si?.image_url) slides.push({ url: getImageUrl(si.image_url), label: null });
  });
  const defects = [
    ...(item?.defects || []),
    ...(item?.sub_items || []).flatMap(si => si?.defects || [])
  ];
  defects.forEach(d => {
    const url = d?.defect_image_url ?? d?.defectImageUrl;
    if (url) slides.push({ url: getImageUrl(url), label: defectLabel });
  });
  return slides;
};

export const getFirstSlideUrl = (item, defectLabel) => {
  return buildImageSlides(item, defectLabel)[0]?.url ?? null;
};
